const observers = new WeakMap();
export const vReveal = {
    mounted(el, binding) {
        el.classList.add('reveal');
        const delay = binding.value?.delay ?? 0;
        if (delay)
            el.style.setProperty('--reveal-delay', `${delay}ms`);
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                el.classList.add('reveal--visible');
                observer.unobserve(el);
            }
        }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
        observer.observe(el);
        observers.set(el, observer);
    },
    unmounted(el) {
        observers.get(el)?.disconnect();
        observers.delete(el);
    },
};
export default vReveal;
